import React from "react";
import { Theme, withTheme, WithTheme } from "@material-ui/core/styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTh } from "@fortawesome/pro-solid-svg-icons/faTh";
import { faThList } from "@fortawesome/pro-solid-svg-icons/faThList";

import { Orientation } from "../constants";

interface OrientationOptionProps extends WithTheme {
  orientation: Orientation;
  isSelected: boolean;
}

const iconMap = {
  [Orientation.Vertical]: faTh,
  [Orientation.Horizontal]: faThList
};

const getIconColor = (isSelected: boolean, theme: Theme) =>
  isSelected ? theme.palette.primary.main : theme.palette.grey[500];

const OrientationIconBase: React.FC<OrientationOptionProps> = ({
  isSelected,
  orientation,
  theme
}) => {
  const color = getIconColor(isSelected, theme);
  const name = iconMap[orientation];
  return <FontAwesomeIcon color={color} icon={name} />;
};

export const OrientationIcon = withTheme()(OrientationIconBase);
